module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_10_2.338403ab.jpg";